import {
ChangeDetectionStrategy,
ChangeDetectorRef,
Component,
HostListener,
OnDestroy,
OnInit,
ViewChild
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute,ResolveData,Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, firstValueFrom, Observable, of, Subject, Subscription, switchMap } from 'rxjs';
import { map,share,skip,take,takeUntil,tap,withLatestFrom } from 'rxjs/operators';
import { NewOnSiteEventComponent,NewOnSiteEventComponentDialogData } from 'src/app/dave-commission-module/components/new-on-site-event/new-on-site-event.component';
import { PersonEntity, Salutation } from '../../../dave-data-module/entities/person.entity';
import {
    Person2EntityEntity,
    Person2EntityEntityTypeEnum,
} from '../../../dave-data-module/entities/person2entity.entity';
import { BookmarkResolver } from '../../../dave-data-module/guards/bookmark.resolver';
import { CommentResolver } from '../../../dave-data-module/guards/comment.resolver';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { ComplaintTypeResolver } from '../../../dave-data-module/guards/complaintType.resolver';
import { CustomerResolver } from '../../../dave-data-module/guards/customer.resolver';
import { EventTypeResolver } from '../../../dave-data-module/guards/event-type.resolver';
import { ComponentCanDeactivate } from '../../../dave-data-module/guards/pending-changes.guard';
import { PermissionsResolver } from '../../../dave-data-module/guards/permissions.resolver';
import { PersonResolver } from '../../../dave-data-module/guards/person.resolver';
import { PersonTypeResolver } from '../../../dave-data-module/guards/personType.resolver';
import { TokenResolver } from '../../../dave-data-module/guards/token.resolver';
import { UserResolver } from '../../../dave-data-module/guards/user.resolver';
import { State } from '../../../dave-data-module/State';

import { PersonActionTypes } from '../../../dave-data-module/State/actions/person.actions';
import { Person2EntityActionTypes } from '../../../dave-data-module/State/actions/person2entity.action';
import {
getCommissionById,
getCommissions
} from '../../../dave-data-module/State/selectors/commission.selector';
import { getCustomers } from '../../../dave-data-module/State/selectors/customers.selectors';
import { getOwnPartnerOffices } from '../../../dave-data-module/State/selectors/partners.selectors';
import { getPersons } from '../../../dave-data-module/State/selectors/person.selectors';
import {
    getPerson2Entities,
    getPerson2EntitiesByPersonId,
} from '../../../dave-data-module/State/selectors/person2entity.selectors';
import { getViewStyleSetting } from '../../../dave-data-module/State/selectors/viewStyleSetting.selector';
import { EmailEditorComponent,EmailEditorComponentDialogConfig,EmailEditorComponentDialogData } from '../../../dave-email-module/components/email-editor/email-editor.component';
import {
SelectCommissionDialogComponent,
SelectCommissionDialogComponentDialogData
} from '../../../dave-select-user/components/select-user-dialogs/select-commission-dialog/select-commission-dialog.component';
import { SelectCustomerDialogComponentDialogData,SelectCustomerPersonDialogComponent } from '../../../dave-select-user/components/select-user-dialogs/select-customer-person-dialog/select-customer-person-dialog.component';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { PermissionService } from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { RoutingHistoryService } from '../../../dave-utils-module/dave-shared-components-module/services/routing-history.service';
import {  CommissionMeta, CustomerAdministrationMeta } from '../../../helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { PersonDetailFormComponent } from '../person-detail-form/person-detail-form.component';
import { PartnerOfficeResolver } from '../../../dave-data-module/guards/partner-office.resolver';
import { CommissionTypeEntityIdEnum } from '../../../dave-data-module/entities/commissionType.entity';
import { ComplaintTypeIdEnum } from '../../../dave-data-module/entities/complaintType.entity';
import { PersonTypeIdEnum } from '../../../dave-data-module/entities/personType.entity';
import { CommissionEntity } from 'src/app/dave-data-module/entities/commission.entity';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import {
    getCommissionTypeDictionary,
    getCommissionTypesFetched,
} from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getCommissionColorValue } from '../../../helper/helper';
import { CommissionTypeResolver } from '../../../dave-data-module/guards/commissionType.resolver';
import { usersFeatureKey } from '../../../dave-data-module/State/reducers/users.reducer';
import { Person2EntityByPersonIdResolver } from '../../../dave-data-module/guards/Person2EntityByPersonIdResolver';
import { CustomerDataService } from '../../../dave-data-module/services/customer-data.service';

@Component({
    selector: 'app-detail-person',
    templateUrl: './detail-person.component.html',
    styleUrls: ['./detail-person.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailPersonComponent implements ComponentCanDeactivate, OnInit, OnDestroy {
    public static readonly RequiredResolvers: ResolveData = {
        token: TokenResolver,
        permissions: PermissionsResolver,
        persons: PersonResolver,
        personTypes: PersonTypeResolver,
        complaintTypes: ComplaintTypeResolver,
        commissions: CommissionResolver,
     //   customers: CustomerResolver,
    //    person2Entity: Person2EntityResolver,
        eventTypes: EventTypeResolver,
        bookmarkByEvent: BookmarkResolver,
        [usersFeatureKey]: UserResolver,
        comments: CommentResolver,
        partnerOffice: PartnerOfficeResolver,
        person2Entity: Person2EntityByPersonIdResolver
    };

    public Editing$ = new Subject<boolean>();
    public Person$: Observable<PersonEntity> = combineLatest([this.route.paramMap, this.store.select(getPersons)]).pipe(
        map(([paramMap, persons]) => {
            if (paramMap.has('personId')) {
                return persons.find((p) => p.Id === +paramMap.get('personId'));
            } else {
                let p = new PersonEntity();
                return p;
            }
        }),
        tap((person) => this.Editing$.next(person.Id === null)),
        tap(() => this.cdr.detectChanges()),
    );
    public FormDirty = false;
    public FormEmpty = false;
    public FormInvalid = false;
    // private personToEntitys$ = combineLatest([this.Person$, this.store.select(getPerson2Entities)]).pipe(
    //     map(([person, p2e]) => p2e?.filter((p) => p.PersonId === person.Id)),
    //     share(),
    // );

    private personToEntitys$ = this.Person$.pipe(
        switchMap((person) =>
            person.Id != null
                ? this.store.select(getPerson2EntitiesByPersonId(person.Id))
                : of([])
        ),
        share(),
    );

    public Commissions$ = combineLatest([this.store.select(getCommissions), this.personToEntitys$, this.store.select(getViewStyleSetting)]).pipe(
        map(([commissions, p2e]) =>
            p2e?.filter((p) => p.EntityType === Person2EntityEntityTypeEnum.Commission).map((p) => commissions?.find((c) => c.Id === p.EntityId))),
        map((commissions) => commissions.filter((c) => c !== undefined)),

    );

    protected commissionTypes$ = getFetched$(this.store, getCommissionTypesFetched, getCommissionTypeDictionary, this.commissionTypeResolver);

    public ListCardInputCommissions$ =
        combineLatest([
            this.Commissions$,
            this.commissionTypes$,
        ]).pipe(
            map(([commissions, commissionTypeDictionary]) => {
                return commissions.map((commission) => {
                    return {
                        ...commission,
                        colorBarValue: getCommissionColorValue(commission, commissionTypeDictionary[commission.CommissionTypeId]),
                    };
                });
            })
        );


    public Customers$ = this.personToEntitys$.pipe(
        map((p2e) =>
            p2e
                ?.filter((p) => p.EntityType === Person2EntityEntityTypeEnum.Customer)
                .map((p) => p.EntityId) ?? [],
        ),
        switchMap((customerIds) =>
            this.customerDataService.GetCustomersDict$(customerIds),
        ),
        map((customers) => Object.values(customers)),
    );
    protected customerLabel$: Observable<string> = this.cls.getSingle$('CustomerSupplier');
    protected customersLabel$: Observable<string> = this.cls.getMultiple$('CustomerSupplier');
    public CommissionMeta = CommissionMeta;
    public CustomerMeta = CustomerAdministrationMeta;
    public OpenMailDialog$: Subject<void> = new Subject<void>();
    @ViewChild('Form') protected Form: PersonDetailFormComponent;

    constructor(
        private appDialog: AppDialogService,
        private route: ActivatedRoute,
        private routingHistoryService: RoutingHistoryService,
        private store: Store<State>,
        private commissionTypeResolver: CommissionTypeResolver,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        protected ps: PermissionService,
        protected cls: CustomLabelService,
        private customerDataService: CustomerDataService
    ) {
    }

    private subscriptions: Subscription[] = [];

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.OpenMailDialog$.pipe(
                withLatestFrom(this.Person$),
                tap(([, person]) => {
                    this.dialog.open<EmailEditorComponent, EmailEditorComponentDialogData>(EmailEditorComponent, {
                        ...EmailEditorComponentDialogConfig,
                        data: {
                            TargetEmails: [person.Email, person.SecondMail].filter(v => !!v),
                        },
                    });
                }),
            ).subscribe(),
        );
    }

    Save() {
        this.Form.Save();
    }

    public CreateEvent() {
        this.Person$.pipe(take(1)).subscribe((p) => {
            this.dialog.open(NewOnSiteEventComponent, {
                ...NewOnSiteEventComponent.DefaultConfig,
                data: {
                    IsNotOrtstermin: true,
                    PersonId: p.Id,
                    Street: p.Street,
                    PostalCode: p.PostalCode,
                    City: p.City,
                    Country: p.Country,
                } as NewOnSiteEventComponentDialogData,
            });
        });
    }

    public Saved(p: PersonEntity) {
        this.router.navigate(['../', p.Id], { relativeTo: this.route });
    }

    public RouteToCommission(event) {
        this.router.navigate(['/', CommissionMeta.Path, event.entry.Id]);
    }

    public RouteToCustomer(event) {
        this.router.navigate(['/', CustomerAdministrationMeta.Path, event.entry.Id]);
    }

    public DeletePerson(person: PersonEntity) {
        this.appDialog
            .OpenConfirmationDialog({
                paragraph: `${person.DisplayName} wirklich löschen?`,
                styleDelete: true,
            })
            .pipe(take(1))
            .subscribe(([result]) => {
                if (result) {
                    this.store
                        .select(getPersons)
                        .pipe(
                            skip(1),
                            take(1),
                            tap(() => this.routingHistoryService.NavigateBackwards()),
                        )
                        .subscribe();
                    this.store.dispatch(PersonActionTypes.DeletePerson({ Payload: person.Id }));
                }
            });
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.FormDirty;
    }

    onAddCustomerClick() {
        firstValueFrom(this.Person$).then((person) => {
            const bothNames = person.Salutation === Salutation.life_companions && (person.SecondFirstname || person.SecondLastname)
            this.dialog.open<SelectCustomerPersonDialogComponent, SelectCustomerDialogComponentDialogData>(SelectCustomerPersonDialogComponent, {
                ...SelectCustomerPersonDialogComponent.DefaultConfig,
                data: {
                    preventNewPersonDialogWhileCreateCustomer: true,
                    personId: person.Id,
                    newCustomerDefaultValues: {
                        name: person.CompanyName || person.DisplayName || undefined,
                        firstName: bothNames ? [person.Firstname, person.Lastname].filter(v => !!v).join(' ') : person.Firstname,
                        lastName: bothNames ? [person.SecondFirstname, person.SecondLastname].filter(v => !!v).join(' ') : person.Lastname,
                        customer: {
                            Description: person.Description || undefined,
                        },
                        office: {
                            Email: person.Email || undefined,
                            PostalCode: person.PostalCode || undefined,
                            City: person.City || undefined,
                            MobileNumber: person.MobileNumber || undefined,
                            FaxNumber: person.FaxNumber || undefined,
                            PhoneNumber: person.PhoneNumber || undefined,
                            Street: person.Street || undefined,
                            Country: person.Country || undefined,
                            MobileNumber2: person.MobileNumber2 || undefined,
                        },
                    },
                },
            });
        });
    }



    addCommissionClick() {

       firstValueFrom(this.Person$).then((person) => {
            const selectedCommissionIds = this.store.select(getPerson2Entities).pipe(map((person2Entities) =>
                person2Entities.filter((p) => Person2EntityEntityTypeEnum.Commission && p.PersonId === person.Id).map((p) => (p.EntityId)
                )))

           var partnerOfficesId = 0;
           this.store.select(getOwnPartnerOffices).pipe(
               take(1)
           ).subscribe(partnerOffices => {
               partnerOfficesId = partnerOffices.length > 0 ? partnerOffices[0].Id : null;
           });


            const dialogRef = this.dialog.open<SelectCommissionDialogComponent, SelectCommissionDialogComponentDialogData>(SelectCommissionDialogComponent, {
                    ...SelectCommissionDialogComponent.DefaultConfig,
                    data: {
                        selectedCommissionIds$: selectedCommissionIds,
                        newCommissionDefaultValues: {
                            personId: person.Id,
                            partnerOfficeId:  partnerOfficesId
                        },
                        commissionFilter: undefined,
                    },
                }
            );

            let complaintTypeId: number;
           switch(person.PersonTypeId) {
               case PersonTypeIdEnum.klaeger: {
                   complaintTypeId = ComplaintTypeIdEnum.klagender
                   break;
               }
               case PersonTypeIdEnum.beklagter: {
                   complaintTypeId = ComplaintTypeIdEnum.beklagter
                   break;
               }
               case PersonTypeIdEnum.vorsitzender: {
                   complaintTypeId = ComplaintTypeIdEnum.vorsitzender
                   break;
               }
               default: {
                   complaintTypeId = ComplaintTypeIdEnum.beteiligtePerson;
                   break;
               }
           }


            dialogRef.componentInstance.addCommissions
                .pipe(takeUntil(dialogRef.beforeClosed()))
                .subscribe((addedCommissionIds) => {
                    addedCommissionIds.forEach(commissionId => {

                        const commission = this.store.select(getCommissionById({ id: commissionId }))
                        commission.forEach((commission) => {
                            if(commission.CommissionTypeId != CommissionTypeEntityIdEnum.gericht){
                                complaintTypeId = ComplaintTypeIdEnum.beteiligtePerson;
                            }
                        })
                        this.store.dispatch(
                            Person2EntityActionTypes.AddPerson2Entity({
                                Payload: {
                                    personId: person.Id,
                                    entityId: commissionId,
                                    entityType: Person2EntityEntityTypeEnum.Commission,
                                    complaintTypeId: complaintTypeId,
                                },
                            }),
                        );
                    })
                });

            dialogRef.componentInstance.removeCommission
                .pipe(takeUntil(dialogRef.beforeClosed()))
                .subscribe((removedCommissionId) => {
                    const person2EntityId =
                     this.store.select(getPerson2Entities).pipe(
                         take(1),
                         map((person2Entities) =>
                             person2Entities.find(
                                 (p) =>
                                     Person2EntityEntityTypeEnum.Commission &&
                                     p.PersonId === person.Id &&
                                     p.EntityId === removedCommissionId
                             )?.Id
                         )
                     )
                    person2EntityId.forEach((id ) => {
                        this.store.dispatch(Person2EntityActionTypes.DeletePerson2Entity({ Payload: { id } }));
                    })

                });
        });
    }
}
